import { sectionType } from "../../../../sectionType"
import { segmentType } from "../../Corridor/models/segment-type"
import { ColumnDefinition, inclusionEnum } from "../../models/ColumnDefinition/column-definition"
import { columnType } from "./column-type.enum"
import { headType } from "./head-type.enum"

export enum variantEnum { left = 'left', center = 'center', right = 'right' };
export enum subtypeEnum { single = 'single', G = 'G', H = 'H', Custom = 'Custom' };
export enum columnSubtype { moosplaza = 'moosplaza', body = 'body', head = 'head' };

export const columnDefs: ColumnDefinition<columnType | headType, subtypeEnum, segmentType, variantEnum, columnSubtype>[] =
    [
        {
            type: columnType.V_P3,
            bays: 3,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P32_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P31_R]
                        },]
                    },
                    {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P322_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P312_R]
                        },]
                    }]
                }, {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P322_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P312_R]
                        },]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_M_O_TH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2_G_M_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_MK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_G_MK_R]
                        }],
                    }],

                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P32_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P31_R]
                        },],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P322_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P312_R]
                        },],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_LK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_LK_R]
                        }],
                    },
                    {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_L3K_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_L3K_R]
                        }],
                    }]
                }
            ]
        },
        {
            type: columnType.V_P4_1,
            columnSubtypes: [columnSubtype.moosplaza],
            bays: 4,
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P42_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P41_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P422_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P412_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_S1S2_O_TH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2_G_S1S2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_S1S2K_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_G_S1S2K_R]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P42_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P41_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P422_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P412_R]
                        }]
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_M1M2K_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_M1M2K_R]
                        }],
                    },
                    {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_M13M23K_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_M13M23K_R]
                        }],
                    }]
                }
            ]
        },
        {
            type: columnType.V_P4_2,
            columnSubtypes: [columnSubtype.moosplaza],
            bays: 4,
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P42_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P41_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P422_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P412_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_XL_O_TH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2_G_XL_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_XLK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_G_XLK_R]
                        }],
                    }]
                }, {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P42_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P41_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P422_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P412_R]
                        }]
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SLK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_SLK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SL3K_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_SL3K_R]
                        }],

                    }]
                }
            ]
        },
        {
            type: columnType.V_P5,
            columnSubtypes: [columnSubtype.moosplaza],
            bays: 5,
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P52_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P51_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P522_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P512_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_M_O_TH2_R] // TODO bad section type used
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2_2G_M_R] // TODO bad section type used
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_MK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_2G_MK_R]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P52_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P51_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P522_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P512_R]
                        }]
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_LK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_2H_LK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_L3K_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_2H_L3K_R]
                        }],
                    }]
                },
            ]
        },
        {
            type: columnType.V_P4H,
            columnSubtypes: [columnSubtype.moosplaza],
            bays: 4,
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P42H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P41H_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P422H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P412H_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_M_O_TLH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2_G_M_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_MK_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_G_MK_R]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P42H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P41H_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P422H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P412H_R]
                        }]
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_LK_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_LK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_L3K_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_L3K_R]
                        }],
                    }]
                }
            ]
        },
        {
            type: columnType.V_P5H_S1S2,
            columnSubtypes: [columnSubtype.moosplaza],
            bays: 5,
            inclusions: [inclusionEnum.elevator, inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P52H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P51H_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P522H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P512H_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_S1S2_O_TLH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2_G_S1S2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_S1S2K_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_G_S1S2K_R]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P52H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P51H_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P522H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P512H_R]
                        }]
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_M1M2K_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_M1M2K_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_M13M23K_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_M13M23K_R]
                        }],
                    }]
                },
            ]
        },
        {
            type: columnType.V_P5H_XL,
            columnSubtypes: [columnSubtype.moosplaza],
            bays: 5,
            inclusions: [inclusionEnum.elevator, inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P52H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P51H_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P522H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P512H_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_XL_O_TLH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2_G_XL_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_XLK_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_G_XLK_R]
                        }],
                    }]
                }, {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P52H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P51H_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.V_P522H_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.V_P512H_R]
                        }]
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SLK_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_SLK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SL3K_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_SL3K_R]
                        }],
                    }]
                },
            ]
        }, {
            type: columnType.O_TH,
            columnSubtypes: [columnSubtype.body],
            bays: 1,
            uiName: 'trappenhuis',
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TH2BG_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TH2BG2_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TH2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TH2K_R]
                        }],
                    }]
                }
            ]
        }, {
            type: columnType.O_TLH2,
            uiName: 'lift en trappenhuis',
            columnSubtypes: [columnSubtype.body],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            bays: 2,
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TLH2BG_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TLH2BG2_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TLH2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TLH2K_R]
                        }],
                    }]
                }
            ]
        }, {
            type: columnType.G_M,
            columnSubtypes: [columnSubtype.body],
            bays: 2,
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.center,
                                sections: [sectionType.G_MBG_R]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.center,
                                sections: [sectionType.G_MBG2_R]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.G_M_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.G_MK_R]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.H_LBG_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.H_LK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.H_L3K_R] // TODO Check at leon
                        }],
                    }]
                },
            ]
        }, {
            type: columnType.G_S1S2,
            columnSubtypes: [columnSubtype.body],
            bays: 3,
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.center,
                                sections: [sectionType.G_S1S2BG_R]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.center,
                                sections: [sectionType.G_S1S2BG2_R]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.G_S1S2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.G_S1S2K_R]
                        }],
                    }]
                }, {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.H_M1M2BG_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.H_M1M2K_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.H_M13M23K_R]
                        }],
                    }]
                },
            ]
        }, {
            type: columnType.G_L1L2,
            columnSubtypes: [columnSubtype.body],
            bays: 5,
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.center,
                                sections: [sectionType.G_L1L2BG_R]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.center,
                                sections: [sectionType.G_L1L2BG2_R]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.G_L1L2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.G_L1L2K_R]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType._2H_LSBG_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType._2H_LSK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType._2H_L3SK_R]
                        }],
                    }]
                },
            ]
        }, {
            type: columnType.G_XL,
            columnSubtypes: [columnSubtype.body],
            bays: 3,
            inclusions: [],
            uiName: 'XL app.',
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.center,
                                sections: [sectionType.G_XLBG_R]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.center,
                                sections: [sectionType.G_XLBG2_R]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.G_XL_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.G_XLK_R]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.H_SLBG_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.H_SLK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.H_SL3K_R]
                        }],
                    }]
                },
            ]
        }, {
            type: headType.G_M__O_TH2,
            columnSubtypes: [columnSubtype.head],
            bays: 3,
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType.G_MBG_O_TH2_R]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TH2_G_MBG_R]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType.G_MBG2_O_TH2_R]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TH2_G_MBG2_R]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_M_O_TH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2_G_M_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_MK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_G_MK_R]
                        }],
                    }]
                }, {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_LBG_O_TH2BG_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2BG_H_LBG_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_LK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_LK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_L3K_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_L3K_R]
                        }],
                    }]
                },

            ]
        }, {
            type: headType.G_M__O_TLH2,
            columnSubtypes: [columnSubtype.head],
            bays: 4,
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType.G_MBG_O_TLH2_R]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TLH2_G_MBG_R]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType.G_MBG2_O_TLH2_R]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TLH2_G_MBG2_R]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_M_O_TLH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2_G_M_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_MK_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_G_MK_R]
                        }],
                    }]
                }, {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_LBG_O_TLH2BG_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2BG_H_LBG_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_LK_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_LK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_L3K_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_L3K_R]
                        }],
                    }]
                },
            ]
        }, {
            type: headType.G_XL__O_TH2,
            columnSubtypes: [columnSubtype.head],
            bays: 4,
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType.G_XLBG_O_TH2BG_R]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TH2BG_G_XLBG_R]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType.G_XLBG2_O_TH2BG_R]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TH2BG_G_XLBG2_R]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_XL_O_TH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2_G_XL_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_XLK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_G_XLK_R]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SLBG_O_TH2BG_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2BG_H_SLBG_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SLK_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_SLK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SL3K_O_TH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_H_SL3K_R]
                        }],
                    }]
                },
            ]
        }, {
            type: headType.G_XL__O_TLH2,
            columnSubtypes: [columnSubtype.head],
            bays: 5,
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType.G_XLBG_O_TLH2BG_R]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TLH2BG_G_XLBG_R]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType.G_XLBG2_O_TLH2BG_R]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TLH2BG_G_XLBG2_R]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_XL_O_TLH2_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2_G_XL_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.G_XLK_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_G_XLK_R]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SLBG_O_TLH2BG_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2BG_H_SLBG_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SLK_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_SLK_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.H_SL3K_O_TLH2K_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_H_SL3K_R]
                        }],
                    }]
                },
            ]
        },
        {
            type: headType._2G_MH,
            columnSubtypes: [columnSubtype.head],
            bays: 5.5,
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType._2G_MBG_O_TLH2BG_R_H]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TLH2BG_2G_MBG_R_H]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType._2G_MBG2_O_TLH2BG2_R_H]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TLH2BG2_2G_MBG2_R_H]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_M_O_TLH2_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2_2G_M_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_MK_O_TLH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_2G_MK_R_H]
                        }],
                    }]
                }, {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_LBG_O_TLH2BG2_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2BG_2H_LBG_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_LK_O_TLH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_2H_LK_R_H]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_L3_O_TLH2_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_2H_L3K_R_H]
                        }],
                    }]
                },
            ]
        },
        {
            type: headType._2G_LH,
            columnSubtypes: [columnSubtype.head],
            bays: 5.5,
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType._2G_LBG_O_TLH2BG_R_H]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TLH2BG_2G_LBG_R_H]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType._2G_LBG2_O_TLH2BG2_R_H]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TLH2BG2_2G_LBG2_R_H]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_L_O_TLH2_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2_2G_L_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_LK_O_TLH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_2G_LK_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_LSBG_O_TLH2BG_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2BG_2H_LSBG_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_LSK_O_TLH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_2H_LSK_R_H]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_L3S_O_TLH2_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLH2K_2H_L3SK_R_H]
                        }],
                    }]
                },
            ]
        }, {
            type: headType._2G_M,
            columnSubtypes: [columnSubtype.head],
            bays: 4.5,
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType._2G_MBG_O_TH2BG_R_H]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TH2BG_2G_MBG_R_H]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType._2G_MBG2_O_TH2BG2_R_H]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TH2BG2_2G_MBG2_R_H]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_M_O_TH2_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2_2G_M_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_MK_O_TH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_2G_MK_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_LBG_O_TH2BG2_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2BG2_2H_LBG_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_LK_O_TH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_2H_LK_R_H]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_L3_O_TH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_2H_L3K_R_H]
                        }],
                    }]
                },
            ]
        }, {
            type: headType._2G_L,
            columnSubtypes: [columnSubtype.head],
            bays: 4.5,
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType._2G_LBG_O_TH2BG_R_H]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TH2BG_2G_LBG_R_H]
                            }
                        ],
                    }, {
                        floors: 2,
                        variants: [
                            {
                                variant: variantEnum.left,
                                sections: [sectionType._2G_LBG2_O_TH2BG2_R_H]
                            },
                            {
                                variant: variantEnum.right,
                                sections: [sectionType.O_TH2BG2_2G_LBG2_R_H]
                            }
                        ],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_L_O_TH2_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2_2G_L_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.G,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2G_LK_O_TH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_2G_LK_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_LSBG_O_TH2BG_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2BG_2H_LSBG_R_H]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.H,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_LSK_O_TH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_2H_LSK_R_H]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2H_L3SK_O_TH2K_R_H]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TH2K_2H_L3SK_R_H]
                        }],
                    }]
                },
            ]
        }, {
            type: headType._O_TH2,
            columnSubtypes: [columnSubtype.head],
            bays: 1,
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TH2BG_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TH2BG2_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TH2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TH2K_R]
                        }],
                    }]
                }
            ],
        }, {
            type: headType._O_TLH2,
            columnSubtypes: [columnSubtype.head],
            bays: 2,
            inclusions: [inclusionEnum.elevator, inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TLH2BG_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TLH2BG2_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TLH2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.center,
                            sections: [sectionType.O_TLH2K_R]
                        }],
                    }]
                }
            ]
        }
    ];
